import dayjs from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

export const formatDate = (date: string | null): string => {
  if (!date) return '-';
  return dayjs(date).format('DD/MM/YYYY HH:mm');
};

export const formatDateOnly = (date: string | null): string => {
  if (!date) return '-';
  return dayjs(date).format('DD/MM/YYYY');
};

export const formatCNPJ = (cnpj: string): string => {
  return cnpj
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1');
};

export const formatPhone = (phone: string): string => {
  return phone
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1');
};

/**
 * Extrai mensagem de erro da resposta do backend.
 * O backend usa um formato personalizado: { error: true, message: {...}, status_code: 403 }
 */
export const extractErrorMessage = (error: any, fallback: string = 'Erro ao processar solicitação'): string => {
  const data = error?.response?.data;
  if (!data) return fallback;

  // Formato personalizado do backend: { error: true, message: {...}, status_code: ... }
  if (data.message && typeof data.message === 'object') {
    const msg = data.message;
    // { detail: "..." }
    if (msg.detail) return msg.detail;
    // { field_name: ["error1", "error2"] }
    return Object.values(msg).flat().join(', ');
  }
  
  // Formato personalizado do backend: { error: true, message: "string" }
  if (data.message && typeof data.message === 'string') {
    return data.message;
  }

  // Formato DRF padrão: { detail: "..." }
  if (data.detail) return data.detail;
  
  // Formato DRF padrão: { error: "..." }
  if (data.error && typeof data.error === 'string') return data.error;
  
  // Formato DRF padrão: { field_name: ["error1", "error2"] }
  if (typeof data === 'object') {
    const values = Object.values(data);
    if (values.length > 0 && values.every(v => typeof v === 'string' || Array.isArray(v))) {
      return values.flat().join(', ');
    }
  }

  return fallback;
};